import {Grid, Typography} from "@mui/material";
import { Link } from "react-router-dom";
import diego from "../../../Recursos/diego.png";

const Tarjeta_Blog_Home = ({titulo, descripcion,imagen, autor, fechaPublicacion, id}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}} sx={{backgroundColor: '#FAFCFE',  border: '1px solid #E8EAEE', p:3  }}>
            <Link to={`/blog/${id}`} style={{ textDecoration: "none" }}>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography variant='h3'>
                    {titulo}
                </Typography>
            </Grid>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:2}}>
                <Typography variant='body1'>
                    {descripcion}
                </Typography>
            </Grid>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:2}}>
                <img src={diego} width="80px"/>
            </Grid>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:1}}>
                <Typography variant='h5'>
                    {autor}
                </Typography>
            </Grid>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:2}}>
                <Typography variant='small'>
                    {fechaPublicacion}
                </Typography>
            </Grid>
            </Link>
        </Grid>
    )

}
export default Tarjeta_Blog_Home